import { useState, useEffect, useRef } from 'react';
import { Link, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Icon } from '@iconify/react';
import { useForm } from 'react-hook-form';
import '../../../Assets/CSS/register.css';
import { BiArrowBack } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import countries from '../../../Assets/mock_data/Countrycode';
import Login from '../login/Login';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { Modal } from 'react-bootstrap';
import TermsConditions from './TermsConditions';

const Register = () => {
    const navigate = useNavigate();



    const [formData, setFormData] = useState({
        email: "",
        password: "",
        confimPassword: "",
        role: "BUYER",
        firstName: "",
        lastName: "",
        contryName: "",
        contryCode: "+91",
        mobileNumber: "",
        agreesToMembership: false,
        profileImageUrl: "",
        emailVerificationToken: "",
        mobileVerificationToken: "",
    });
    const [mobileVerificationToken, setmobileVerificationToken] = useState("");

    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const confirmPasswordRef = useRef(null);
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const countryNameRef = useRef(null);
    const countryCodeRef = useRef(null);
    const mobileNumberRef = useRef(null);

    const [loginopen, setloginopen] = useState(false);

    const [emailVerified, setEmailVerified] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [verificationError, setverificationError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [phoneVerified, setPhoneVerified] = useState(false);
    const [emailOtp, setEmailOtp] = useState(null);
    const [phoneOtp, setPhoneOtp] = useState(null);
    const [emailTimer, setEmailTimer] = useState(0);
    const [phoneTimer, setPhoneTimer] = useState(0);
    const [showEmailOtpInput, setShowEmailOtpInput] = useState(false);
    const [showPhoneOtpInput, setShowPhoneOtpInput] = useState(false);



    const [isChecked, setIsChecked] = useState(formData.agreesToMembership);
    const [showTermsModal, setShowTermsModal] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
        handleChange({ target: { name: "agreesToMembership", value: !isChecked } });
    };

    console.log("Check ====: ", isChecked)


    useEffect(() => {
        if (verificationError) {
            const timer = setTimeout(() => {
                setverificationError(""); // Clears the error after 5 seconds
            }, 5000);

            return () => clearTimeout(timer); // Cleanup on component unmount
        }
    }, [verificationError]); // Runs when verificationError changes
    // API Call for Signup
    const handleSignup = async (e) => {
        e.preventDefault();


        // Trim all input values
        const trimmedData = {
            ...formData,
            firstName: formData.firstName.trim(),
            lastName: formData.lastName.trim(),
            email: formData.email.trim(),
            password: formData.password.trim(),
            confimPassword: formData.confimPassword.trim(),
            mobileNumber: formData.mobileNumber.trim(),
            // agreesToMembership:formData.agreesToMembership=false
        };
        // Update state with trimmed values
        setFormData(trimmedData);

        if (!trimmedData.firstName) {
            toast.error("First Name is required.")
            return;
        }
        if (!trimmedData.lastName) {
            toast.error("Last Name is required.")
            return;
        }

        if (!trimmedData.email) {
            toast.error("Email is required.")
            return;
        }
        if (!trimmedData.password) {
            toast.error("Password is required.")
            return;
        }
        if (!trimmedData.confimPassword) {
            toast.error("Confirm Password is required.")
            return;
        }
        if (trimmedData.password !== trimmedData.confimPassword) {
            toast.error("Passwords do not match.")
            return;
        }

        if (!trimmedData.contryName) {
            toast.error("Country Name is required.")
            return;
        }
        if (!trimmedData.mobileNumber) {
            toast.error("Mobile Number is required.")
            return;
        }
        // if (!trimmedData.agreesToMembership) {
        //     toast.error("agreesToMembership ")
        //     return;
        // }


        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/signup`,
                trimmedData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                toast.success("Signup successful! Please login to continue");
                navigate("/")
            }

        } catch (error) {
            setErrorMessage(
                error.response?.data?.message || "Signup failed. Please try again."
            );
        }
    };


    // Detect auto-fill on mount
    useEffect(() => {
        setTimeout(() => {
            setFormData((prev) => ({
                ...prev,
                email: emailRef.current?.value || prev.email,
                password: passwordRef.current?.value || prev.password,
                confimPassword: confirmPasswordRef.current?.value || prev.confimPassword,
                firstName: firstNameRef.current?.value || prev.firstName,
                lastName: lastNameRef.current?.value || prev.lastName,
                contryName: countryNameRef.current?.value || prev.contryName,
                contryName: countryCodeRef.current?.value || prev.contryName,
                mobileNumber: mobileNumberRef.current?.value || prev.mobileNumber,
            }));
        }, 100);
    }, []);

    function handleOpenLogin() {
        setloginopen(true)
    }

    const handleCloseLogin = () => setloginopen(false);  // Close modal

    const [timer, setTimer] = useState(300); // Timer set to 5 minutes (600 seconds)
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const [showEmailOTP, setShowEmailOTP] = useState(false);
    const [showPhoneOTP, setShowPhoneOTP] = useState(false);
    const [showpassword, setShowPassword] = useState(false);
    const [showconfirmpassword, setShowConfirmPassword] = useState(false);
    const [otpEmailInputs, setOtpEmailInputs] = useState(Array(6).fill(''));
    const [otpPhoneInputs, setOtpPhoneInputs] = useState(Array(6).fill(''));
    const [paused, setPaused] = useState(false);

    const emailotpRefs = useRef([]);
    const phoneotpRefs = useRef([]);

    const handleEmailOtpChange = (index, value) => {
        setOtpEmailInputs((prevOtpInputs) => {
            const newOtpInputs = [...prevOtpInputs];
            newOtpInputs[index] = value.replace(/[^0-9]/g, '');

            // Auto-focus next input
            if (value && index < newOtpInputs.length - 1) {
                emailotpRefs.current[index + 1].focus();
            } else if (!value && index > 0) {
                emailotpRefs.current[index - 1].focus();
            }

            // If all inputs are filled, pause the timer
            if (newOtpInputs.every((input) => input !== '')) {
                setPaused(true);
            }

            const otpString = newOtpInputs.join(''); // Convert to string
            console.log("OTP String:", otpString);
            setEmailOtp(otpString); // Asynchronously updates emailOtp

            return newOtpInputs;
        });
    };
    const handlePhonelOtpChange = (index, value) => {
        setOtpPhoneInputs((prevOtpInputs) => {
            const newOtpInputs = [...prevOtpInputs];
            newOtpInputs[index] = value.replace(/[^0-9]/g, '');

            // Auto-focus next input
            if (value && index < newOtpInputs.length - 1) {
                phoneotpRefs.current[index + 1].focus();
            } else if (!value && index > 0) {
                phoneotpRefs.current[index - 1].focus();
            }

            // If all inputs are filled, pause the timer
            if (newOtpInputs.every((input) => input !== '')) {
                setPaused(true);
            }

            const otpString = newOtpInputs.join(''); // Convert to string
            console.log("OTP String:", otpString);
            setPhoneOtp(otpString); // Asynchronously updates emailOtp

            return newOtpInputs;
        });
    };


    const handleVerifyEmail = async () => {

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/validate-email`, {
                email: formData.email,
            });

            if (response.status === 200) {


                toast.success("OTP has been sent on Email Id: " + formData.email);
                setEmailTimer(16);
                setShowEmailOtpInput(true);
            } else {
                toast.error('Failed to verify phone number');
            }
        } catch (error) {
            toast.error("Email already exists.");
            // toast.error(error.response?.data?.message);
        }
    };

    useEffect(() => {
        let emailInterval, phoneInterval;
        if (emailTimer > 0) {
            emailInterval = setInterval(() => {
                setEmailTimer((prev) => prev - 1);
            }, 1000);
        }
        if (phoneTimer > 0) {
            phoneInterval = setInterval(() => {
                setPhoneTimer((prev) => prev - 1);
            }, 1000);
        }
        return () => {
            clearInterval(emailInterval);
            clearInterval(phoneInterval);
        };
    }, [emailTimer, phoneTimer]);

    const handleVerifyPhoneNumber = async () => {
        setPhoneTimer(4);
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/validate-mobile-number`, {
                countryCode: formData.contryCode,
                mobileNumber: formData.mobileNumber
            });

            if (response.status === 200) {
                console.log("OTP has been sent on Mobile Number: ", formData.mobileNumber);

                toast.success("OTP has been sent on Mobile Number: " + formData.mobileNumber);
                setPhoneTimer(16);
                setShowPhoneOtpInput(true);
            } else {
                toast.error('Failed to verify phone number');
            }
        } catch (error) {
            toast.error("Mobile Number already exists.");
        }
    };

    const handleVerifyEmailOtp = async () => {

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/verify-email-otp`, {
                email: formData.email,
                otp: Number(emailOtp)
            });

            if (response.status === 200) {
                toast.success('Email verified successfully');
                setEmailVerified(true);
                setFormData({ ...formData, emailVerificationToken: response.data.randomToken })
                setShowEmailOtpInput(false)
            } else {
                toast.error('Failed to verify email OTP');
            }
        } catch (error) {
            console.log(error);
            setverificationError(error)
            toast.error(error);
        }
    };

    const handleVerifyPhoneOtp = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/verify-mobile-otp`, {
                contryCode: formData.contryCode,
                mobileNumber: formData.mobileNumber,
                otp: Number(phoneOtp)
            });

            if (response.status === 200) {
                toast.success(response.data.message);
                setPhoneVerified(true);
                // setmobileVerificationToken(response.data.randomToken)
                setFormData({ ...formData, mobileVerificationToken: response.data.randomToken })
                // setOtpPhoneInputs(false)
                setOtpPhoneInputs(Array(6).fill(''));
                setShowPhoneOtpInput(false);
            } else {
                toast.error('Failed to verify phone OTP');
            }
        } catch (error) {
            toast.error(error);
        }
    };

    const handleChange = (e) => {


        const { name, value, type, checked } = e.target;
        let updatedValue = value;
        console.log("---------", name);
        // setFormData((prevData) => ({
        //     ...prevData,
        //     [name]: type === "checkbox" ? checked : value,
        // }));
        if (name == "email") {
            setEmailVerified(false)
        }
        if (name == "mobileNumber") {
            updatedValue = value.replace(/\D/g, '').slice(0, 10); // Only digits & max 10
            setPhoneVerified(false)
        }
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : updatedValue,
        }));
    };

    useEffect(() => {
        let interval = null;
        if ((showEmailOTP || showPhoneOTP) && timer > 0 && !paused) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0 || paused) {
            setIsResendEnabled(true);
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [showEmailOTP, showPhoneOTP, timer, paused]);


    return (
        <div className='container-fluid p-5 mt-4' style={{ background: ' #F7FFEA' }}>
            <div onClick={() => navigate(-1)}> <BiArrowBack /></div>
            <div className="container d-flex pt-5 justify-content-center" style={{ minHeight: '100vh', backdropFilter: 'blur(5px)' }}>
                <div className="p-4 shadow w-100" style={{ background: '#FFFFFF', borderRadius: '30px', maxWidth: '700px' }}>
                    <h1 className="fw-bold fs-4 text-start">Welcome</h1>
                    <p className="text-start fs-6">Please enter your details to create your account</p>
                    <form >
                        {/* Select Role */}
                        <div className="mb-4 text-start">
                            <label className="form-label text-secondary">Select your role*</label>
                            <div className="d-flex gap-3">
                                <label className="border fs-6" style={{ width: '150px', padding: '7px', borderRadius: '13px' }}>
                                    <input type="radio"
                                        name="role" value="SELLER"
                                        checked={formData.role === "SELLER"}
                                        onChange={handleChange} className="me-2"
                                        required /> Seller
                                </label>
                                <label className="border fs-6" style={{ width: '150px', padding: '7px', borderRadius: '13px' }}>
                                    <input type="radio" name="role" value="BUYER" className="me-2 radio-input" checked={formData.role === "BUYER"} onChange={handleChange} required /> Buyer

                                </label>
                            </div>
                        </div>

                        {/* First & Last Name */}
                        <div className="row mb-4">
                            <div className="col-md-6 position-relative">
                                <label className="form-label text-secondary">First Name*</label>
                                <input type="text" ref={firstNameRef}
                                    className=" px-5 form-control rounded-pill "
                                    name="firstName" value={formData.firstName}
                                    onChange={handleChange}
                                />
                                <Icon icon='iconamoon:profile-light'
                                    style={{
                                        color: '#C3C3C3',
                                        position: 'absolute', top: '68%', left: '25px',
                                        transform: 'translateY(-50%)', fontSize: '20px'
                                    }}
                                />
                            </div>
                            <div className="col-md-6 position-relative">
                                <label className="form-label text-secondary">Last Name*</label>
                                <input ref={lastNameRef} type="text"
                                    className="  px-5 form-control rounded-pill position-relative"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange} />
                                <Icon icon='iconamoon:profile-light'
                                    style={{
                                        color: '#C3C3C3',
                                        position: 'absolute', top: '68%', left: '25px',
                                        transform: 'translateY(-50%)', fontSize: '20px'
                                    }}
                                />
                            </div>
                        </div>

                        {/* Email */}
                        <div className="row mb-4">
                            <div className="col-md-6 mb-3 mb-md-0">
                                <label htmlFor="email" className="form-label text-secondary">Enter email*</label>
                                <div className="input-group fs-6">
                                    {emailVerified && (
                                        <Icon
                                            icon="weui:done2-outlined"
                                            className="fs-5 text-success position-absolute"
                                            style={{
                                                right: '30px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                zIndex: 1,
                                                color: '#c3c3c3'
                                            }}
                                        />
                                    )}
                                    <input ref={emailRef} type="email"
                                        className="form-control rounded-pill ps-5"
                                        name="email" value={formData.email}
                                        onChange={handleChange} required />
                                    <Icon icon="bi:envelope" className="fs-5 position-absolute" style={{ left: '20px', top: '50%', transform: 'translateY(-50%)', color: '#c3c3c3' }} />
                                </div>
                            </div>
                            {!emailVerified && formData.email &&
                                // <div className="col-md-3 pt-4 d-flex  ">
                                //         <button className="reg-btn btn-green px-5 rounded-pill py-2" type='button' onClick={handleVerifyEmail}>
                                //             Verify
                                //         </button>
                                //     </div>

                                <div className="col-md-3 pt-4 d-flex  align-items-center justify-content-center ">
                                    {/* Show the Verify button only when phone number is valid */}
                                    <button className="btn  reg-btn btn-green w-md-25 w-100 py-2 rounded-pill"
                                        onClick={handleVerifyEmail}
                                        type='button'
                                    // disabled={!formData.mobileNumber} // Disable button if phone number is not valid
                                    >
                                        Verify
                                    </button>
                                </div>
                            }
                        </div>

                        {/*  Email OTP Section */}

                        {showEmailOtpInput && (// Show OTP section only if showOTP is true
                            <div className="row mb-3">
                                {verificationError && <p className='text-danger' >{verificationError}</p>}
                                <div className="col-md-6">
                                    <label className="form-label text-secondary">Enter verification code</label>
                                    <div className="d-flex  gap-1">
                                        {otpEmailInputs.map((input, index) => (
                                            <input
                                                required
                                                key={index}
                                                type="text"
                                                maxLength={1}
                                                value={input}
                                                onChange={(e) => handleEmailOtpChange(index, e.target.value)}
                                                className="form-control text-center"
                                                ref={(ref) => emailotpRefs.current[index] = ref}
                                                style={{ width: '50px' }}
                                            />
                                        ))}

                                    </div>
                                </div>
                                <div className="col-md-3 pt-4">
                                    <button
                                        type='button'
                                        className="btn reg-btn btn-green w-md-25 w-100 py-2 rounded-pill"
                                        onClick={handleVerifyEmailOtp}
                                    // disabled={!isResendEnabled} // Disable button until timer is up
                                    >
                                        Verify OTP
                                    </button>


                                </div>
                                <p
                                    className="pt-2 rounded-pill"
                                    style={{
                                        color: emailTimer > 0 ? 'gray' : '#FDC400',
                                        cursor: emailTimer > 0 ? 'not-allowed' : 'pointer',
                                    }}
                                    onClick={emailTimer <= 0 ? handleVerifyEmail : undefined}
                                >
                                    Resend OTP {emailTimer > 0 ? `(${emailTimer}s)` : ""}
                                </p>
                                {/* // <button className='reg-btn btn-green px-5 rounded-pill py-2' onClick={handleVerifyEmail}>Verify</button> */}
                            </div>
                        )}

                        {/* Passwords */}
                        <div className="row mb-4">
                            <div className="col-md-6 position-relative">
                                <label className="form-label text-secondary">Password*</label>
                                <input ref={passwordRef}
                                    type={showpassword ? 'text' : 'password'}
                                    className="px-5 form-control rounded-pill"
                                    name="password" value={formData.password}
                                    onChange={handleChange} required />
                                <Icon icon='mdi:password-outline'
                                    style={{
                                        color: '#C3C3C3',
                                        position: 'absolute', top: '68%', left: '25px',
                                        transform: 'translateY(-50%)', fontSize: '20px'
                                    }}
                                />
                                <Icon
                                    icon={showpassword ? "ep:hide" : "hugeicons:view"}
                                    style={{
                                        color: '#371300',
                                        position: 'absolute', top: '68%', right: '25px',
                                        transform: 'translateY(-50%)', fontSize: '20px',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => setShowPassword(!showpassword)}
                                />
                            </div>
                            <div className="col-md-6 position-relative">
                                <label className="form-label text-secondary">Confirm Password*</label>
                                <input ref={confirmPasswordRef}
                                    type={showconfirmpassword ? 'text' : 'password'}
                                    className="px-5 form-control rounded-pill"
                                    name="confimPassword" value={formData.confimPassword}
                                    onChange={handleChange} required />
                                <Icon icon='mdi:password-outline'
                                    style={{
                                        color: '#C3C3C3',
                                        position: 'absolute', top: '68%', left: '25px',
                                        transform: 'translateY(-50%)', fontSize: '20px'
                                    }}
                                />
                                <Icon icon={showconfirmpassword ? 'ep:hide' : 'hugeicons:view'}
                                    style={{
                                        color: '#371300',
                                        position: 'absolute', top: '68%', right: '25px',
                                        transform: 'translateY(-50%)', fontSize: '20px',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => setShowConfirmPassword(!showconfirmpassword)}
                                />
                            </div>
                        </div>

                        {/* Country */}
                        <div className="mb-4 position-relative">
                            <div className="col-md-6">
                                <label className="form-label text-secondary">Country*</label>
                                <select className="px-5 form-select rounded-pill"
                                    name="contryName" value={formData.contryName} onChange={handleChange} required>
                                    <option value="">Select Country</option>
                                    {countries.map((country, index) => (
                                        <option key={index} value={country.label}>{country.label}</option>
                                    ))}
                                </select>
                                <Icon icon='mdi:web'
                                    style={{
                                        color: '#C3C3C3',
                                        position: 'absolute', top: '73%', left: '20px',
                                        transform: 'translateY(-50%)', fontSize: '20px'
                                    }}
                                />
                            </div>


                        </div>

                        {/* Phone */}
                        {/* <div className="mb-4">
                <label className="form-label text-secondary">Phone*</label>
                <div className="d-flex">
                    <select className="form-select rounded-pill me-2" name="countryCode" value={formData.countryCode} onChange={handleChange} required>
                        {countries.map((country, index) => (
                            <option key={index} value={country.value}>{country.value}</option>
                        ))}
                    </select>
                    <input type="tel" className="form-control rounded-pill" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} required />
                </div>
            </div> */}

                        {/* Phone */}
                        <div className="row mb-3 ">
                            <div className="col-md-6 mb-3 mb-md-0">
                                <label htmlFor="phone" className="form-label font-size text-secondary">Enter phone*</label>

                                {/* Parent div needs position-relative */}
                                <div className="input-group position-relative">

                                    <select
                                        placeholder="+91"
                                        className="  ol-3 rounded-pill me-2 px-1"
                                        id="country"
                                        style={{ border: '0.5px solid #c7c7c7' }}
                                        name="contryCode"
                                        value={formData.contryCode}
                                        onChange={handleChange} required
                                    // {...register('country', { required: 'Country is required' })}
                                    >
                                        {
                                            countries.map((country, index) => (
                                                <option key={index} value={country.value}>{country.value}</option>
                                            ))
                                        }
                                    </select>
                                    {phoneVerified && (
                                        <Icon
                                            icon="weui:done2-outlined"
                                            className="fs-5 text-success position-absolute"
                                            style={{
                                                right: '30px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                zIndex: 1,
                                                color: '#c3c3c3'
                                            }}
                                        />
                                    )}
                                    {/* Phone number input */}
                                    <input
                                        type="tel"
                                        className=" form-control rounded-pill"
                                        placeholder="12345 67890"
                                        name="mobileNumber"
                                        inputMode="numeric"         /* brings up the numeric keypad on mobile */
                                        pattern="[0-9]*"            /* hints that only digits are allowed */
                                        maxLength={10}
                                        value={formData.mobileNumber}
                                        onChange={handleChange}
                                        required
                                        style={{ border: '0.5px solid #c7c7c7' }}
                                    />
                                </div>
                                {/* {errors.phones && <p style={{ color: 'red' }}>{errors.phones.message}</p>} */}
                            </div>
                            {formData.mobileNumber && !phoneVerified && (
                                <div className="col-md-3 pt-4 d-flex  align-items-center justify-content-center ">
                                    {/* Show the Verify button only when phone number is valid */}
                                    <button className="btn  reg-btn btn-green w-md-25 w-100 py-2 rounded-pill"
                                        onClick={handleVerifyPhoneNumber}
                                        type='button'
                                        disabled={!formData.mobileNumber} // Disable button if phone number is not valid
                                    >
                                        Verify
                                    </button>
                                </div>
                            )}



                        </div>

                        {/*  phone OTP Section */}


                        {showPhoneOtpInput && (// Show OTP section only if showOTP is true
                            <div className="row mb-3">
                                {verificationError && <p className='text-danger' >{verificationError}</p>}
                                <div className="col-md-6">
                                    <label className="form-label text-secondary">Enter verification code</label>
                                    <div className="d-flex  gap-1">
                                        {otpPhoneInputs.map((input, index) => (
                                            <input
                                                key={index}
                                                type="text"
                                                maxLength={1}
                                                value={input}
                                                onChange={(e) => handlePhonelOtpChange(index, e.target.value)}
                                                className="form-control text-center"
                                                ref={(ref) => phoneotpRefs.current[index] = ref}
                                                style={{ width: '50px' }}

                                            />
                                        ))}

                                    </div>
                                </div>
                                <div className="col-md-3 pt-4">
                                    <button
                                        type='button'
                                        className="btn reg-btn btn-green w-md-25 w-100 py-2 rounded-pill"
                                        onClick={handleVerifyPhoneOtp}
                                    // disabled={!isResendEnabled} // Disable button until timer is up
                                    >
                                        Verify OTP
                                    </button>


                                </div>
                                <p
                                    className="pt-2 rounded-pill"
                                    style={{
                                        color: emailTimer > 0 ? 'gray' : '#371300',
                                        cursor: emailTimer > 0 ? 'not-allowed' : 'pointer',
                                    }}
                                    onClick={emailTimer <= 0 ? handleVerifyPhoneNumber : undefined}
                                >
                                    Resend OTP {emailTimer > 0 ? `(${emailTimer}s)` : ""}
                                </p>
                                {/* // <button className='reg-btn btn-green px-5 rounded-pill py-2' onClick={handleVerifyEmail}>Verify</button> */}
                            </div>
                        )}

                        {/* Terms */}
                        {/* <div className="form-check mb-3 col-md-11">
                            <input type="checkbox" 
                            className="form-check-input custom-checkbox"
                             name="agreesToMembership" 
                             checked={formData.agreesToMembership} onChange={handleChange} />
                            <label className="form-check-label text-secondary">
                                I agree to Membership Agreement,  Terms of Use, and Privacy Policy.<br/>
                                I agree to receive more information from ..... about its products and services.
                                Agree and Register
                            </label>
                        </div> */}


                        <div className="form-check  p-0 mb-5 col-md-11 d-flex  position-relative " style={{ marginTop: '40px' }}>
                            {/* Hidden Default Checkbox */}
                            <input
                                type="checkbox"
                                className="form-check-input custom-checkbox"
                                name="agreesToMembership"
                                checked={isChecked}
                                // onChange={handleCheckboxChange}
                                onChange={() => setShowTermsModal(true)}
                                required
                            />
                            {/* Custom Styled Icon */}
                            <span className="custom-checkbox-icon "
                                // onClick={handleCheckboxChange}
                                onClick={() => setShowTermsModal(true)}

                            >
                                {isChecked ? (
                                    <Icon icon="mdi:checkbox-outline" className="checkbox-icon" />
                                ) : (
                                    <Icon icon="mdi:checkbox-blank-outline" className="checkbox-icon" />
                                )}
                            </span>

                            {/* Checkbox Label */}
                            <label htmlFor="membershipCheckbox"
                                className=" aggree-text form-check-label text-secondary ">
                                I agree to Membership Agreement, Terms of Conditions, and Privacy Policy.<br />
                                I agree to receive more information from ..... about its products and services.<br />
                                Agree and Register
                            </label>
                            {/* Terms and Conditions Modal */}
                            <Modal
                                show={showTermsModal}
                                onHide={() => setShowTermsModal(false)}
                                size="lg"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Terms and Conditions</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <TermsConditions />
                                </Modal.Body>
                                <Modal.Footer>
                                    <button
                                        className="btn "
                                        style={{ backgroundColor: '#371300', color: 'white' }}
                                        onClick={() => {
                                            setShowTermsModal(false);
                                            setIsChecked(true);
                                        }}
                                    >
                                        I Agree
                                    </button>
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            setShowTermsModal(false);
                                            setIsChecked(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </Modal.Footer>
                            </Modal>
                        </div>

                        {/* Submit Button */}
                        <button type="submit" onClick={handleSignup}
                            disabled={!isChecked} // 👈 This disables the button if checkbox is not checked
                            className="btn reg-btn btn-green px-lg-5 w-50 rounded-pill">
                            Create Account</button>


                        {/* Success/Error Messages */}
                        {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
                        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
                    </form>
                    {/* Login Redirect */}
                    <div className="text-start mt-3" onClick={handleOpenLogin}>
                        Already have an account?<span style={{ color: "#371300", cursor: 'pointer' }}> Login</span>
                    </div>
                </div>
            </div>
            {loginopen && <Login onClose={handleCloseLogin} loginopen={loginopen} />}
        </div>
    );
};

export default Register;




